<template>
  <section class="display-table">
    <div class="vertical-align-middle">
      <b-container class="bv-example-row">
        <b-row>
          <b-col
            cols="10"
            md="4"
            class="center-col text-center vertical-align-middle"
          >
            <b-form @submit="onSubmit">
              <img class="center-col" src="../assets/logo-promart.png" />
              <b-form-group class="padding-nine-top">
                <b-form-input
                  v-model.trim="form.username"
                  type="text"
                  required
                  class="border-radius-20"
                  placeholder="Usuario"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  v-model.trim="form.password"
                  type="password"
                  required
                  placeholder="Contraseña"
                  class="border-radius-20"
                ></b-form-input>
              </b-form-group>
              <b-form-checkbox
                id="checkbox-1"
                v-model="isProvider"
                name="checkbox-1"
              >
                Proveedor
              </b-form-checkbox>
              <b-button
                class="width-auto bg-orange-btn"
                type="submit"
                variant="primary"
                :disabled="isLoading"
              >
                INGRESAR</b-button
              >
              <!--<p class="padding-three-top">
                En caso no recuerdes tu contraseña llama al :
                <span class="text-orange"> ****-***</span>
              </p> -->
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        username: "",
        password: "",
        isProvider: false,
      },
      isProvider: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapMutations("module", ["setAuthToken"]),
    async loginProvider() {
      try {
        this.isLoading = true;
        let response = await axios.post(
          process.env.VUE_APP_LOGIN_PROVIDER_BASE + "/provider",
          {
            user: this.form.username,
            password: this.form.password,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );

        const opciones = [
          {
            id: 1,
            name: "AdministracionOs",
            accesoPorUsuario: false,
            posicion: "02",
            description: "Administracion Os",
            nivelAnidamiento: 1,
          },
          {
            id: 2,
            name: "DetalleOS",
            accesoPorUsuario: false,
            posicion: "0201",
            description: "Detalle Os",
            nivelAnidamiento: 2,
          },
          {
            id: 3,
            name: "ProgramaciónOS",
            accesoPorUsuario: false,
            posicion: "0203",
            description: "Programación OS",
            nivelAnidamiento: 2,
          },
          {
            id: 4,
            name: "ConfirmaciónOS",
            accesoPorUsuario: false,
            posicion: "0204",
            description: "Confirmación OS",
            nivelAnidamiento: 2,
          },
          {
            id: 5,
            name: "Tecnicos",
            accesoPorUsuario: false,
            posicion: "03",
            description: "Tecnicos",
            nivelAnidamiento: 1,
          },
          {
            id	:	37,
            name: "ProgramacionMasiva",
            description	:	"Programación Masiva",
            posicion	:	"0137",
            nivelAnidamiento	:	1,
            accesoPorUsuario	:	false,

          },
          {
            id: 14,
            name: "Crear",
            accesoPorUsuario: false,
            posicion: "03",
            description: "Crear",
            nivelAnidamiento: 2,
          },
          {
            id: 15,
            name: "Editar",
            accesoPorUsuario: false,
            posicion: "03",
            description: "Editar",
            nivelAnidamiento: 2,
          },
          {
            id: 19,
            name: "Inactivar",
            accesoPorUsuario: false,
            posicion: "03",
            description: "Inactivar",
            nivelAnidamiento: 2,
          },
          {
            id: 27,
            name: "ReporteProveedor",
            accesoPorUsuario: false,
            posicion: "0211",
            description: "ReporteProveedor",
            nivelAnidamiento: 2,
          },
          {
            id: 28,
            name: "Reportes",
            accesoPorUsuario: true,
            posicion: "06",
            description: "Reportes",
            nivelAnidamiento: 1,
          },
          {
            id: 32,
            name: "ReportesServicios",
            accesoPorUsuario: true,
            posicion: "0602",
            description: "Reportes Servicios",
            nivelAnidamiento: 2,
          },
          {
            id	:	9,
            name: "TrackingOS",
          descripcion	:	"Tracking OS",
          posicion	:	"0202",
          nivelAnidamiento	:	2,
          accesoPorTipo	:	true,
          accesoPorUsuario	:	false,

          }
          
        ];
        var obj = {
          status: true,
          username: this.form.username,
          store: [{ codigo: response.data.user.branches[0].storeCode }],
          perfil: "PROVEEDOR",
          options: opciones,
          idProvider: response.data.user.id,
          name: response.data.user.name,
        };
        this.$store.commit("module/setAuthToken", obj);
        console.log(response);
        this.$router.push({ path: "/admin-os" });
      } catch (error) {
        this.isLoading = false;
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async generateTokenApiGee(){
       try {
        
        let response = await axios.post(
          "https://migracion.api.promart.pe/oauth/client_credential/accesstoken?grant_type=client_credentials",
         {
          data:""
         },
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Basic cjRSRXBTWlBia2QzOTN1RzM4R0c5UzZLTnNZR0c1TWFXRk9zTFlaR0FqRTh2NWFqOmtVa0cwNTFiMkhTa1FWZmc0SjBHOWkwOU1CQnBjS2ZNc29BNlpBWVowMXFKY1ZjakFYSkd1TlVRdXBtdFVTV0c="
            },
          }
        );
        console.log(response.data)
        this.$store.commit("module/setToken", response.data.access_token);
      } catch (error) {
        console.log(error);
      } 
    },
    async loginUser() {
      try {
        this.isLoading = true;
        let response = await axios.post(
          process.env.VUE_APP_LOGIN_SS ,
          {
        
            usuario: this.form.username,
            clave: this.form.password,
            codigo: 92,
            abreviatura: "SRVC",
            host: "0.0.0.0",
            ip: "0.0.0.0",
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
              company: "HP",
            },
          }
        );

        if (response.data.status === 0) {
          this.isLoading = false;
          let values = { variant: "danger", msg: response.data.message };
          this.$store.commit("setShowAlert", true);
          this.$store.commit("SET_ERROR_MSG", values);
          return;
        }
        let opciones = response.data.poucu_opciones.map((row) => {
          return {
            id: row.cod_opc,
            name: row.des_opc.split(" ").join(""),
            accesoPorUsuario: "",
            description: row.des_opc,
            nivelAnidamiento: parseInt(row.nivel),
            posicion: row.cod_niv2,
          };
        });

        var obj = {
          status: true,
          username: this.form.username,
          store: [],
          perfil: "HP",
          options: opciones,
          idProvider: 0,
          name: "",
        };
        this.$store.commit("module/setAuthToken", obj);
        this.$router.push({ path: "/admin-os" });
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.isLoading = false;
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async onSubmit(event) {
      event.preventDefault();
      if (this.isProvider) {
        this.generateTokenApiGee();
        this.loginProvider();
      } else {
        this.generateTokenApiGee();
        this.loginUser();
      }
    },
  },
};
</script>
<style scoped>
.border-radius-20 {
  border-radius: 20px;
}
.center-col {
  float: none;
  margin-right: auto;
  margin-left: auto;
}
.text-center {
  text-align: center;
}
.padding-nine-top {
  padding-top: 9%;
}
.width-auto {
  width: 100%;
}
.bg-orange {
  background: rgb(254, 123, 1);
}
.padding-three-top {
  padding-top: 3%;
}
.vertical-align-middle {
  display: table-cell;
  vertical-align: middle;
}
.display-table {
  display: table;
  height: 100%;
  background-color: rgb(235, 235, 235);
  width: 100%;
}
.text-orange {
  color: rgb(254, 123, 1);
}
</style>
